import { NgModule } from '@angular/core';
import { InvestigatorModule } from '../investigator/investigator.module';
import { SharedModule } from '../shared/shared.module';
import { SitesModule } from '../sites/sites.module';
import { NotificationBarContent } from './notification-bar-content';
import { NotificationBarComponent } from './notification-bar.component';
import { NotificationIconComponent } from './notification-icon.component';

@NgModule({
    declarations: [NotificationBarComponent, NotificationIconComponent],
    imports: [SharedModule, InvestigatorModule, SitesModule],
    exports: [NotificationBarComponent, NotificationIconComponent],
    providers: [NotificationBarContent]
})
export class NotificationBarModule { }